import { PaymentMethod } from '@/api/types';

export function formatEuro(cents: number): string {
  return new Intl.NumberFormat('sl-SI', { style: 'currency', currency: 'EUR' }).format(cents / 100);
}

export function paymentMethodLabel(method: PaymentMethod | null | undefined): string {
  if (method === PaymentMethod.Card) return 'kartica';
  if (method === PaymentMethod.BankTransfer) return 'bančno nakazilo';
  return '';
}

/** "12,50" / "12.5" -> 1250; empty -> null; anything else -> NaN. */
export function parseEuroToCents(text: string): number | null {
  const t = text.trim().replace(',', '.');
  if (!t) return null;
  if (!/^\d+(\.\d{1,2})?$/.test(t)) return Number.NaN;
  return Math.round(Number.parseFloat(t) * 100);
}

export function centsToEuroText(cents: number | null): string {
  return cents == null ? '' : (cents / 100).toFixed(2).replace('.', ',');
}
